import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { Link } from "react-router-dom";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Button,
  Divider,
  Grid,
  TextField,
} from "@material-ui/core";
import faker from "faker-br";
import Modal from "./../../../../components/modal/index";
import { Search, Save, ArrowLeft } from "react-feather";

function OpenGrupo() {
  const classes = useStyles();

  const [dados, setDados] = useState([]);

  const [open, setOpen] = useState(false);

  

  const Open = () => {
    setOpen(open ? false : true);
  };
  const Close = () => {
    setOpen(open === false);
  };

  const generate = () => {
    let item = [];
    for (let i = 0; i < 1; i++) {
      item.push(
        {
          id: faker.random.number(),
          nome: faker.random.number(),
          cnpj: faker.random.number(),
          acao: faker.random.number(),
        },
      );
      setDados(item);
    }
    item.sort((a, b) => (a.nome_razao < b.nome_razao ? -1 : 1));
  };

  useEffect(() => {
    generate();
  }, []);

  return (
    <>
      <div className={classes.prontuarios}>
     
        <div className={classes.prontuariosContainer}>
        <Link to="/app/operador/grupos/view">
        <ArrowLeft style={{color: 'grey'}} />
        </Link>
          <div className={classes.center}>
            <h1>Empresa</h1>
          </div>
          <Divider />
          <br />
          <b>Nome</b>: Matriz
          <br />
          <b>Cnpj </b>: 00123123000100
          <br />
          <br />
          <Divider />
          <br />
          <div style={{ float: "right" }}>
            <Button
              style={{
                backgroundColor: "#000041",
                color: "#fff",
              }}
              onClick={() => Open()}
            >
              Criar Prontuário
            </Button>
            &nbsp;
            <Button
              style={{
                backgroundColor: "#1DA7A4",
                color: "#fff",
              }}
              onClick={() => Open()}
            >
             Listar Prontuário
            </Button>
            &nbsp;
            <Link to="/app/operador/grupos/open/users" style={{  textDecoration: "none"}}>
            <Button
              style={{
                backgroundColor: "#1DA7A4",
                color: "#fff",
                textDecoration: "none"
              }}
            >
             Usuário Contatos
            </Button>
            </Link>
          </div>
          <br />
          <br />
          <br />
          <br />
          <TableContainer>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Descrição</TableCell>
                  <TableCell>Ativos</TableCell>
                  <TableCell>Inativos</TableCell>
                  <TableCell>Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dados.map((item) => {
                  return (
                    <>
                      <TableRow key={item.id}>
                        <TableCell><b>Geral</b></TableCell>
                        <TableCell>{item.id}</TableCell>
                        <TableCell>{item.nome}</TableCell>
                        <TableCell>{item.cnpj}</TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Modal
            open={open}
            style={{ padding: "20px 30px", width: "40%" }}
            title="Criar Prontuário"
            buttons={[
              {
                title: "Localizar",
                icon: <Search height="1.5em" width="1.5em" />,
                style: { color: "green", fontSize: "14px" },
                onClick: () => Close("Salvou"),
              },
            ]}
          >
            <br />
            <TextField
              fullWidth
              label="Empresa: "
              id="fullWidth"
              value="Support Empresarial"
              margin="dense"
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Cnpj:"
              id="fullWidth"
              value="00123123000100"
              margin="dense"
              variant="outlined"
            />
            <Divider/>
            <p style={{fontSize: '12px'}}>Localizar Funcionario</p>
            <TextField
              fullWidth
              label="Nome ou CPF"
              margin="dense"
              variant="outlined"
            />
            <br />
          </Modal>
        </div>
      </div>
    </>
  );
}

export default OpenGrupo;
